export enum ChipVariant {
  PRIMARY_FILLED = 'primary-filled',
  PRIMARY_LEAKED = 'primary-leaked',
  SECONDARY_FILLED = 'secondary-filled',
  POSITIVE_LIGHT = 'positive-light',
  POSITIVE_DARK = 'positive-dark',
  NEGATIVE = 'negative',
  WARNING = 'warning',
  INFO = 'info',
  NEUTRAL_FILLED = 'neutral-filled',
  NEUTRAL_LEAKED = 'neutral-leaked',
  NOT_VISIBLE = 'not-visible',
  SUCCESS_FILLED = 'SUCCESS_FILLED'
}

export enum ChipSize {
  SMALL = 'small',
  NORMAL = 'normal',
  LARGE = 'large',
  EXTRA_LARGE = 'extra-large'
}
